const React = require('react');
const BrandBrickPt = require('./brandbrickPT');
const BrandBrickEs = require('./brandbrickES');
const BrandBrickREPt = require('./brandbrickREPT');
const BrandBrickREEs = require('./brandbrickREES');

const BrandBrick = {
  es: BrandBrickEs,
  pt: BrandBrickPt,
  en: BrandBrickEs,
  're-pt': BrandBrickREPt,
  're-es': BrandBrickREEs,
  're-en': BrandBrickREEs,
};

module.exports = BrandBrick;
